import React from 'react'
import { useSelector } from 'react-redux'

import { userSelectors } from '../../redux/userSlice'
import { UserTypes } from '../../util/constants'
import PersonalUserDashboard from './PersonalUserDashboard'
import BusinessUserDashboard from './BusinessUserDashboard'

const Dashboard = () => {
    const user = useSelector(userSelectors.userDetails)

    return user.userType === UserTypes.Business ? (
        <BusinessUserDashboard />
    ) : (
        <PersonalUserDashboard />
    )
}

export default Dashboard
